const values = [
  "DailytrialChest",
  "EventDarkChest",
  "EventFireChest",
  "EventLightChest",
  "EventNatureChest",
  "EventNPEChest",
  "EventPhysicChest",
  "EventWaterChest",
  "FrostTowerChest",
  "HeroChest",
  "HeroChestT1",
  "HeroChestT2",
  "HeroChestT3",
  "HeroChestT4",
  "HeroChestT5",
  "HeroChestT6",
  "LightHouseTowerChest",
  "PremiumChest",
  "SpellChest",
  "SpellChestT1",
  "SpellChestT2",
  "SpellChestT3",
  "SpellChestT4",
  "SpellChestT5",
  "SpellChestT6",
  "TowerChest",
  "TowerChestT1",
  "TowerChestT2",
  "TowerChestT3",
  "TowerChestT4",
  "TowerChestT5",
  "TowerChestT6",
  "WoodChest",
];
export default values;
